import { Box, SkeletonGroup } from '@wix/design-system';
import React from 'react';
import { ProductCardsSkeleton } from '../../components/ProductCards/ProductCardsSkeleton';
import { HeaderSkeleton } from './HeaderSkeleton';

export const SelectPlanPageSkeleton = () => {
  return (
    <SkeletonGroup>
      <Box direction="vertical" width="100%" align="center">
        <HeaderSkeleton />
        <ProductCardsSkeleton />
      </Box>
    </SkeletonGroup>
  );
};
